/**
 * @generated SignedSource<<7c6c5a0af805beb8ae79b1b3bdafb84b>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ZakekeEnvironment = "AI_STUDIO" | "COMPOSER" | "CUSTOMIZER" | "UNKNOWN" | "VIEWER";
export type StarredMenuQuery$variables = {
  environment: ZakekeEnvironment;
};
export type StarredMenuQuery$data = {
  readonly quickAccessMenu: {
    readonly keys: ReadonlyArray<string>;
  } | null;
};
export type StarredMenuQuery = {
  response: StarredMenuQuery$data;
  variables: StarredMenuQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "environment"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "environment",
        "variableName": "environment"
      }
    ],
    "concreteType": "QuickAccessMenu",
    "kind": "LinkedField",
    "name": "quickAccessMenu",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "keys",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "StarredMenuQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "StarredMenuQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "b7be535015aba3ab27e8485b98b89aa7",
    "id": null,
    "metadata": {},
    "name": "StarredMenuQuery",
    "operationKind": "query",
    "text": "query StarredMenuQuery(\n  $environment: ZakekeEnvironment!\n) {\n  quickAccessMenu(environment: $environment) {\n    keys\n  }\n}\n"
  }
};
})();

(node as any).hash = "450c89e037f9be3c6a69cfcd9d45fc56";

export default node;
